<template>
    <v-col class="d-flex pa-0 pr-2" cols="12" sm="6" md="3">
        <v-text-field
            class="mr-2"
            :value="csvName"
            :label="$t('importFromCsv.importFromCsv')"
            readonly="readonly"
            prepend-inner-icon="mdi-upload"
            @click="pickCsv"
        />
        <input
            ref="csv"
            name="csv"
            style="display: none"
            type="file"
            @change="setCsv"
        />
        <v-btn
            class="mt-2"
            :disabled="!csvName"
            depressed
            medium
            @click="onCsvUpload"
            >{{ $t('importFromCsv.import') }}</v-btn
        >
    </v-col>
</template>

<script>
export default {
    name: 'importFromCsv',

    data() {
        return {
            csvName: ''
        };
    },

    methods: {
        pickCsv() {
            this.$refs.csv.click();
        },
        setCsv(e) {
            const [file] = e.target.files;

            this.csvName = file.name;
        },
        async onCsvUpload() {
            const [csvFile] = this.$refs.csv.files;

            this.$emit('upload', csvFile);
            this.csvName = '';
            this.$refs.csv.value = null;
        }
    }
};
</script>
